import React , {useState} from "react";
import { IconButton, InputAdornment, Grid, Typography, CircularProgress, Button } from "@mui/material";
import { GroupItem, ParentContainer, SignIn4Inner, RectangleDiv, GroupChild1, GroupChild2, GroupInner, LogoBox, ForgotPasswordDetails, LoginContainer} from "./Authorization.style";
import ThemeColor from "../../theme/ThemeColor";
import { H5FormLabel, H7TablePrimeContent, H2MainText, H3MainText, H4MainText, H4FormLabel} from "../../theme/Theme";
import { CustemButton, InputBox } from "../../components/Custom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LessThanIcon from "../../components/Icons/LessThanIcon"
import validate from "../../validation/validation";
import DisplayError from '../../validation/DisplayError';
import { EyeCloseIcon, EyeOpenIcon } from "../../components/Icons";
import { useDispatch } from "react-redux";
import { changePassword, forgotPasswordDetails, sendOPTToUser } from "../../redux/Thunk/authThunk";
import Swal from "sweetalert2";
import image from "../../asserts/LALogistic-1.png"
import SignInImage from "../../asserts/LoginImage.jpg";

const ResetPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {state} = useLocation()
    const [error, setError] = useState([])
    const [buttonDisabled, setButtonDisabled] = useState(false)
    const [showPassword, setShowPassword] = useState(true);
    const [showConfirmPassword, setShowConfirmPassword] = useState(true);
    const [loader, setLoader] = useState(false)
    const [password, setPassword] = useState({
        resetPassword:'',
        confirmPassword:''
    }) 
   
    const handleChangePassword =(e) =>{
        setPassword((prevFormData) => ({...prevFormData, [e.target.name]:e.target.value?.trim()}));
    }
   
    let validation_input = [
        {tagid: 'password', text: password?.resetPassword, required: true, regex_name: 'password', errmsg: 'Please Enter Password.'}, 
        {tagid: 'confirmPassword', text: password?.confirmPassword, required: true, regex_name: 'password', errmsg: 'Please Enter Password.'}, 
    ]

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    }

    const submitSendOTP = () =>{
        if(validate(validation_input).length == 0){
            setButtonDisabled(true)
            if(password?.confirmPassword === password?.resetPassword){
                const passwordDetails ={
                    Email: state?.Email,
                    Password:password?.resetPassword,
                    otp:state?.otp,
                    ConfirmPassword:password?.confirmPassword
                }
                setLoader(true)
              dispatch(changePassword(passwordDetails)).then((res)=>{
                if(res?.payload?.success === false){
                    Swal.fire({ title: res?.payload?.message, icon: "error"})
                    setButtonDisabled(false)
                }else{
                    Swal.fire({ title: res?.payload?.message, icon: "success"})
                    setButtonDisabled(false)
                    navigate('/')
                }
               setLoader(false)
              })
            }else{
              setError([])
              setButtonDisabled(false)
              Swal.fire({ title: "Reset and Confirm Password does not match.", icon: "error"})
            }
        }else{
            setError(validate(validation_input))
        } 
    }

    return(
        <>
        <LoginContainer>
            {/* Display Image */}
            <Grid container>
            <Grid size={{ xs: 12, sm: 10, md: 10, lg:8 }} style={{display:'flex', justifyContent:"center"}}>
                <img src={SignInImage} alt="Login" style={{ width: 'auto', height: '100vh', objectFit: 'cover'}} />
            </Grid>

            {/* Employee Forget Password Details */}
            <Grid size={{ xs: 12, sm: 10, md: 10, lg:4 }} style={{background:'#F1F1F1', borderBottomRightRadius:'10px', borderTopRightRadius:'10px', height:'auto', maxWidth:'100%'}}>
                <LogoBox>
                    <img src={image} width={172} height={165} alt="" style={{objectFit: 'cover'}}/>
                </LogoBox>
                
                <ForgotPasswordDetails>
                    <Grid container spacing={{ xs: 2, md: 2, lg: 2 }} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", }} >
                    {/* Display form */}
                    <Grid item xs={12} md={6} sm={6} lg={8}>
                        <H5FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Reset Password</H5FormLabel>
                        <InputBox name="resetPassword" type={showPassword ? "password" : "text"} onChange={handleChangePassword} sx={{ borderRadius: "10px", height: "50px", border: "2px solid rgba(0, 0, 0, 0.3)", fontSize: "14px", width: "100%", p: 0.1, pl: 2}} placeholder="Enter Password" 
                            onPaste={(e) => e.preventDefault()} onCopy={(e) => e.preventDefault()} endAdornment={ <InputAdornment position="end"> <IconButton style={{ ml: 1 }} aria-label="toggle password visibility" onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword} > {showPassword ? <EyeCloseIcon /> : <EyeOpenIcon />} </IconButton> </InputAdornment> }      
                        />                
                        <DisplayError error={error} fortagid='password'/>
                    </Grid>
                    <Grid item xs={12} md={6} sm={6} lg={8}>
                        <H5FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Confirm Password </H5FormLabel>
                        <InputBox name="confirmPassword" type={showConfirmPassword ? "password" : "text"} onChange={handleChangePassword} sx={{ borderRadius: "10px", height: "50px", border: "2px solid rgba(0, 0, 0, 0.3)", fontSize: "14px", width: "100%", p: 0.1, pl: 2}} placeholder="Enter Password" 
                            onPaste={(e) => e.preventDefault()} onCopy={(e) => e.preventDefault()}  endAdornment={ <InputAdornment position="end"> <IconButton style={{ ml: 1 }} aria-label="toggle password visibility" onClick={handleClickShowConfirmPassword}
                            onMouseDown={handleMouseDownPassword} > {showConfirmPassword ? <EyeCloseIcon /> : <EyeOpenIcon />} </IconButton> </InputAdornment> }      
                        />  
                        <DisplayError error={error} fortagid='confirmPassword'/>                               
                    </Grid>
                        <Typography sx={{color:'#000000', fontSize:'10px', letterSpacing:0.5}}>(Password must be at least 8 characters long and include 1 uppercase letter, 1 number, and 1 special character.)</Typography>
                    </Grid>
                    <Grid sx={{ display: "flex", flexDirection: "row", justifyContent: "center"}} >
                        <Button
                            id="validate"
                            variant="contained"
                            disabled={loader}
                            onClick={submitSendOTP}
                            sx={{
                                color: '#FFFFFF',
                                backgroundColor: '#3107AA',
                                '&:hover': { backgroundColor: '#3107AA', color: '#FFFFFF' },
                                fontSize: '16px', 
                                fontWeight: '500',
                                borderRadius:"10px",
                                textTransform: 'none', 
                                width:'100%', height:'40px',
                                margin:'15px',
                                boxShadow:'0px 4px 6px #e1e1e1'
                            }}
                        >
                            {loader ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
                        </Button>
                    </Grid>
                </ForgotPasswordDetails>
                </Grid>
            </Grid>
        </LoginContainer>
        </>
    )
}

export default ResetPassword